<div auto="outputs-edit-heading-header" class="sidebar-header">Edit Headings</div>
<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="headingsForm">
  <label class="standard-label" for="objectiveHeading">Objectives</label>
  <div class="input-error-wrap sans-margin">
    <input auto="edit-headings-objective-heading"
           id="objectiveHeading"
           type="text"
           class="standard-input block"
           name="objectiveHeading"
           formControlName="objectiveHeading"
           required maxlength="20"/>
    <div class="remaining-msg">Remaining: {{objectiveHeadingRemainingCharacters}}</div>
    <app-error-msg [control]="objectiveHeadingField"
                   [show]="objectiveHeadingField.invalid && objectiveHeadingField.touched">
    </app-error-msg>
  </div>
  <label class="standard-label" for="initiativeHeading">Critical Initiatives</label>
  <div class="input-error-wrap sans-margin">
    <input auto="edit-headings-initiative-heading"
           id="initiativeHeading"
           type="text"
           class="standard-input block"
           name="initiativeHeading"
           formControlName="initiativeHeading"
           required maxlength="20"/>
    <div class="remaining-msg">Remaining: {{initiativeHeadingRemainingCharacters}}</div>
    <app-error-msg [control]="initiativeHeadingField"
                   [show]="initiativeHeadingField.invalid && initiativeHeadingField.touched">
    </app-error-msg>
  </div>
  <label class="standard-label" for="keyMeasureHeading">Key Measure(s)</label>
  <div class="input-error-wrap sans-margin">
    <input auto="edit-headings-keyMeasure-heading"
           id="keyMeasureHeading"
           type="text"
           class="standard-input block"
           name="keyMeasureHeading"
           formControlName="keyMeasureHeading"
           required maxlength="20"/>
    <div class="remaining-msg">Remaining: {{keyMeasureHeadingRemainingCharacters}}</div>
    <app-error-msg [control]="keyMeasureHeadingField"
                   [show]="keyMeasureHeadingField.invalid && keyMeasureHeadingField.touched">
    </app-error-msg>
  </div>
  <div class="button-row">
    <button auto="edit-headings-cancel-btn" class="btn btn-alt left-btn" type="button" (click)="onCancel()">Cancel</button>
    <button auto="edit-headings-save-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
